import { inject, Pipe, PipeTransform } from "@angular/core";
import { Store } from "@ngxs/store";
import { OrganizationState } from "@vp/data-access/organization";
import { TagsState } from "@vp/data-access/tags";
import { Organization, Tag } from "@vp/models";
import { filterNullMap } from "@vp/shared/operators";
import { Observable } from "rxjs";
import { map, shareReplay, withLatestFrom } from "rxjs/operators";

@Pipe({
  name: "tagsArray",
  standalone: false
})
export class TagsArrayPipe implements PipeTransform {
  organization$: Observable<Organization | null> = inject(Store).select(
    OrganizationState.organization
  );
  tags$: Observable<Tag[]> = inject(Store).select(TagsState.tags);

  public transform(tagIds: string[]): Observable<string> {
    return this.organization$.pipe(
      filterNullMap(),
      shareReplay(),
      withLatestFrom(this.tags$.pipe(shareReplay())),
      map(([org, tags]: [Organization, Tag[]]) => {
        return getTagArraysDisplay(tagIds, org, tags);
      })
    );
  }
}

export const getTagArraysDisplay = (tagIds: string[], org: Organization, tags: Tag[]) => {
  const tagDisplayNames: string[] = [];
  tagIds?.forEach((tagId: string) => {
    let tagDisplayName = "[tag not found]";
    const tag = tags.find(t => t.tagId === tagId);
    if (tag !== undefined) {
      tagDisplayName = tag.displayName;
      const tagType = org.tagTypes.find(r => r.tagTypeId === tag.tagTypeId);
      if (tagType !== undefined) {
        tagDisplayName = `${tagType.displayName}: ${tag.displayName}`;
      }
    }
    tagDisplayNames.push(tagDisplayName);
  });
  return tagDisplayNames.sort().join(", ");
};
